import { generateAboutURL } from "../../../src/services/url";
import {
  CURRENCY,
  CUSTOM_DETAILS,
  LOCATION,
  DOMAIN_MATCHER
} from "../../constants";

import {
  getInstallment,
  getTitles,
  createQueryString,
} from "./utils";

import { getParams } from '../../getParams';

const ASSETS_ENV_URL = getParams(DOMAIN_MATCHER, '/assets').domain;

export const CustomPoints = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  containerClass = "",
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
  defaultWidget,
}) => {
  const productDetails = (CUSTOM_DETAILS[merchantId] ?? CUSTOM_DETAILS[currency]).products;
  const { amount, length } = getInstallment(price, promotionMonths);

  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );

  const { POINTS_TITLE } = getTitles({
    length,
    amount,
    price,
    currency,
    aboutURL,
    defaultWidget,
    merchantId
  });

  return `
  <!-- Latitude Interest Free Snippet - Start -->
  <div
    style="font-size: 14px; margin: 10px 0px; font-weight:450; display: flex; flex-wrap: wrap;"
    class="${containerClass}">
      <div style="display: flex; flex-direction: row; margin: 5px 10px 0 0;">
        ${
          productDetails.map(product => {
            return `<img
              style="height:20px; margin: 0 2px 0 2px;"
              src="${`${ASSETS_ENV_URL}/${product.productLogo}`}"
              alt="custom-product-logo"
            />`
          }).join("")
        }
      </div>
      ${POINTS_TITLE}
  </div>
  <!-- Latitude Interest Free Snippet - End -->
  `;
};
